import React from 'react'

import SubstanceFormLubricant from '../../Form/Lubricant'

const SubstanceContainerLubricant = () => <SubstanceFormLubricant />

export default SubstanceContainerLubricant
